(function () {
  const MQ = window.matchMedia('(max-width: 767.98px)');

  function getSlides(scrollEl) {
    return scrollEl.querySelectorAll(
      '.coveo-search-card-wrapper:not(.coveo-rec-skeleton), .f-column.card:not(.coveo-rec-skeleton)'
    );
  }

  function activeIndex(scrollEl, slides) {
    if (!slides.length) return 0;
    const scrollRect = scrollEl.getBoundingClientRect();
    const viewMid = scrollEl.scrollLeft + scrollEl.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    slides.forEach((slide, i) => {
      const sr = slide.getBoundingClientRect();
      const slideLeft = scrollEl.scrollLeft + sr.left - scrollRect.left;
      const mid = slideLeft + sr.width / 2;
      const d = Math.abs(mid - viewMid);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    });
    return best;
  }

  function updateDots(dotsRoot, scrollEl, slides) {
    const idx = activeIndex(scrollEl, slides);
    dotsRoot.querySelectorAll('.section--trending-boats__dot').forEach((btn, i) => {
      btn.classList.toggle('is-active', i === idx);
    });
  }

  function scrollToIndex(scrollEl, slides, index) {
    const slide = slides[index];
    if (!slide) return;
    const left =
      scrollEl.scrollLeft +
      slide.getBoundingClientRect().left -
      scrollEl.getBoundingClientRect().left;
    scrollEl.scrollTo({ left, behavior: 'smooth' });
  }

  function bindDots(dotsRoot, scrollEl) {
    let raf = null;
    const onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        raf = null;
        updateDots(dotsRoot, scrollEl, getSlides(scrollEl));
      });
    };

    scrollEl.addEventListener('scroll', onScroll, { passive: true });
    return () => scrollEl.removeEventListener('scroll', onScroll);
  }

  function buildDots(dotsRoot, scrollEl) {
    const slides = getSlides(scrollEl);
    const n = slides.length;

    dotsRoot.innerHTML = '';
    if (n < 2) {
      dotsRoot.hidden = true;
      return null;
    }
    dotsRoot.hidden = false;

    for (let i = 0; i < n; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'section--trending-boats__dot' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.addEventListener('click', () => {
        const s = getSlides(scrollEl);
        scrollToIndex(scrollEl, s, i);
      });
      dotsRoot.appendChild(btn);
    }

    updateDots(dotsRoot, scrollEl, slides);
    return bindDots(dotsRoot, scrollEl);
  }

  function initDotsRoot(dotsRoot) {
    if (typeof dotsRoot._trendingCleanup === 'function') {
      dotsRoot._trendingCleanup();
      dotsRoot._trendingCleanup = null;
    }

    if (!MQ.matches) {
      dotsRoot.hidden = true;
      return;
    }

    const targetId = dotsRoot.dataset.scrollTarget;
    if (!targetId) return;

    const scrollEl = document.getElementById(targetId);
    if (!scrollEl) return;

    let unbind = buildDots(dotsRoot, scrollEl);

    const mo = new MutationObserver(() => {
      if (unbind) unbind();
      unbind = buildDots(dotsRoot, scrollEl);
    });
    const inner = scrollEl.querySelector('[id^="coveo-headless-recommendations"], .products-grid');
    mo.observe(inner || scrollEl, { childList: true, subtree: true });

    const onResize = () => {
      if (!MQ.matches) {
        dotsRoot.hidden = true;
        return;
      }
      if (unbind) unbind();
      unbind = buildDots(dotsRoot, scrollEl);
    };
    window.addEventListener('resize', onResize);

    MQ.addEventListener('change', onResize);

    dotsRoot._trendingCleanup = () => {
      mo.disconnect();
      window.removeEventListener('resize', onResize);
      MQ.removeEventListener('change', onResize);
      if (unbind) unbind();
    };
  }

  function init() {
    document.querySelectorAll('[data-trending-dots]').forEach((root) => {
      initDotsRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (!window.__trendingBoatsMqBound) {
    window.__trendingBoatsMqBound = true;
    MQ.addEventListener('change', init);
  }
})();
